import * as TanStackQueryProvider from "@fp/ui/integrations/tanstack-query/root-provider";
import type { RouteIds } from "@tanstack/react-router";
import { createRouter } from "@tanstack/react-router";
import { RouteError } from "./components/route-error";
// Import the generated route tree
import { routeTree } from "./routeTree.gen";

const TanStackQueryProviderContext = TanStackQueryProvider.getContext();
// Set up a Router instance
const router = createRouter({
  routeTree,
  context: {
    ...TanStackQueryProviderContext,
  },
  defaultPreload: "intent",
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
  defaultErrorComponent: RouteError,
});

export type RouterType = typeof router;
export type RouterIds = RouteIds<RouterType["routeTree"]>;

// Register the router instance for type safety (use a unique context type for talent app)
declare module "@tanstack/react-router" {
  interface Register {
    // Use a unique property name to avoid conflict with admin app
    router: typeof router;
  }
  interface HistoryState {
    returnTo?: string;
    returnLabel?: string;
    // add other state properties you use
  }
}

export { router };

export type { ErrorComponentProps } from "@tanstack/react-router";

// By re exporting the api from TanStack router, we can enforce that other packages
// rely on this one instead, making the type register being applied
export {
  ErrorComponent,
  getRouteApi,
  Link,
  Outlet,
  RouterProvider,
  useRouteContext,
  useRouter,
} from "@tanstack/react-router";
